import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { BestIndex } from "../components/best/BestIndex";
import { bestIndexHead } from "../lib/best/head";
import { bestIndexPath, loadBestCopy } from "../lib/best/index";
import { BEST_UI } from "../lib/best/ui";
import { siteLangOf } from "../lib/marketing/registry";
import { documentHeaders } from "../lib/seo";

/** `/<lang>/best`. */
export const Route = createFileRoute("/$lang/best/")({
  loader: async ({ params }) => {
    const lang = siteLangOf(params.lang);
    if (!lang) throw notFound();

    const path = bestIndexPath(lang);
    if (path !== `/${params.lang}/best`)
      throw redirect({ href: path, statusCode: 301 });

    return { lang, copy: await loadBestCopy(lang) };
  },
  headers: documentHeaders,
  head: ({ loaderData }) =>
    loaderData
      ? bestIndexHead(
          loaderData.lang,
          BEST_UI[loaderData.lang],
          loaderData.copy,
        )
      : {},
  component: LocalizedBestIndex,
});

function LocalizedBestIndex() {
  const { lang, copy } = Route.useLoaderData();
  return <BestIndex lang={lang} ui={BEST_UI[lang]} copy={copy} />;
}
